<template>
	<div id="" style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
		<img style="width: 60%;margin: 140px 0 20px 0" src="../../public/images/wx_logo.png" >
		<button @click="openMiro"  type="button" style="padding:10px 20px;border-radius: 10px;background-color:#409eff;border: none;color: white;font-size: 22px;">打开小程序</button>
	</div>
</template>

<script>
	export default {
		methods: {
			openMiro() {
				window.open('weixin://dl/business/?t=ZdIgqCNJ9Bm', '_self'); 
				// console.log('打开小程序')
			}
		}
	}
</script>

<style>
</style>
